module.exports = {
    url: 'https://blogapi634.herokuapp.com'
}